import React from "react";
import {  Statistic, Card, Row, Col } from 'antd'
import Table from "antd/es/table";
import { UserIcon } from "../Icon";
import { Typography, Button, List } from 'antd';
import {
  Avatar,
} from "@webiz/admin-design-system";
const { Text, Paragraph } = Typography;

const TopClients = () => {
  const arr = [
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
 
  ]
  
  return (
    <div className="top-clients-card">
      <Card className="card-content">
      <Text className="artists-header">Top Clients</Text>
        <Card type="inner" title={
        <div className="inner-title">
          <Text>Clients</Text>
          <Text>Paying</Text>
        </div>
        }>
         <div>
            {arr.map(obj => (
              <div className="card-cols">
                <div className="card-three-elements">
                  <Avatar size="xs"/>       
                  <Text className="client-name">{obj.name}</Text>
                  <Text className="client-email">{obj.email}</Text>
                </div>
                <Text className="client-price">${obj.price}</Text>
              </div>
            ))}
          </div>
          <div className="card-btn-container">
            <Button className="card-btn" type="link">View All</Button>
          </div> 

        </Card>

      </Card>
  </div>
  )
}

export default TopClients;


